import { ManageEngagementsPage } from "../../modules/manage-engagements"
 
interface ManageEngagementsProps {
  sidebarOpen?: boolean
}

export default function ManageEngagements({sidebarOpen }: ManageEngagementsProps) {
  return <ManageEngagementsPage/>
}
